import { render, staticRenderFns } from "./newMaterialXl.vue?vue&type=template&id=17663dd1&scoped=true&"
import script from "./newMaterialXl.vue?vue&type=script&lang=js&"
export * from "./newMaterialXl.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialXl.vue?vue&type=style&index=0&id=17663dd1&lang=less&scoped=true&"
import style1 from "./newMaterialXl.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17663dd1",
  null
  
)

component.options.__file = "newMaterialXl.vue"
export default component.exports